import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import withAnimation from '@shared/components/utils/hoc/withAnimation';

const ChannelListEventArrowLeftContainer = styled.div<{ opacity: number }>`
  position: fixed;
  top: ${522 * Screen.widthRatio}px;
  right: ${1300 * Screen.widthRatio}px;
  opacity: ${(props) => props.opacity || 0};
`;

export default withAnimation(ChannelListEventArrowLeftContainer);
